import { type Component } from 'vue'

import { IconEyes } from '@ds/icons/IconEyes'
import { IconSparkles } from '@ds/icons/IconSparkles'

export const PICKER_ICONS: Record<string, Component> = {
  IconEyes,
  IconSparkles,
}

export const EMPHASIS_TO_COLOR = {
  default: 'default',
  info: 'cornflower',
  accent: 'purple',
}
